module.exports = __webpack_public_path__ + "static/media/iconoCerrarBuscar.ec7c9fc4.svg";